import {Component, Input, OnInit} from '@angular/core';
import {AdvService} from "../../core/advertisement/service/advertisement.service";
import {Advertisement} from "../../core/advertisement/advertisement.component";


@Component({
    selector: 'app-offer-product',
    templateUrl: './offer-product.component.html',
    imports: [],
    styleUrls: ['./offer-product.component.css']
})
export class OfferProductComponent implements OnInit {

  imageSrc1: any;
  imageSrc2: any;
  @Input() advertisement!: Advertisement[];

  imageLoaded: boolean[] = [false, false];

  constructor(private advService:AdvService) {}

  onImageLoad(index: number): void {
    this.imageLoaded[index] = true;
  }

  ngOnInit(): void {}

}
